import React, { ChangeEvent } from 'react';

type Props = {
    label: string | React.ReactElement;
    onChangeCallback: (event: ChangeEvent<HTMLInputElement>) => void;
};

/**
 * A simple, non-formik checkbox used in some confirmation modals
 */
const ModalConfirmCheckbox = (props: Props) => (
    <div className="checkbox">
        <label htmlFor="checkbox">
            <input
                type="checkbox"
                data-testid="modal-confirm-checkbox"
                onChange={props.onChangeCallback}
            />
            {props.label}
        </label>
    </div>
);

export default ModalConfirmCheckbox;
